/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to estimate cost from page counts
 * @export
 * @interface EstimateBillingFromPageCountsRequest
 */
export interface EstimateBillingFromPageCountsRequest {
    /**
     * Array of page counts for each document
     * @type {Array<number>}
     * @memberof EstimateBillingFromPageCountsRequest
     */
    pageCounts: Array<number>;
}

/**
 * Check if a given object implements the EstimateBillingFromPageCountsRequest interface.
 */
export function instanceOfEstimateBillingFromPageCountsRequest(value: object): value is EstimateBillingFromPageCountsRequest {
    if (!('pageCounts' in value) || value['pageCounts'] === undefined) return false;
    return true;
}

export function EstimateBillingFromPageCountsRequestFromJSON(json: any): EstimateBillingFromPageCountsRequest {
    return EstimateBillingFromPageCountsRequestFromJSONTyped(json, false);
}

export function EstimateBillingFromPageCountsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EstimateBillingFromPageCountsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'pageCounts': json['pageCounts'],
    };
}

export function EstimateBillingFromPageCountsRequestToJSON(json: any): EstimateBillingFromPageCountsRequest {
    return EstimateBillingFromPageCountsRequestToJSONTyped(json, false);
}

export function EstimateBillingFromPageCountsRequestToJSONTyped(value?: EstimateBillingFromPageCountsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pageCounts': value['pageCounts'],
    };
}

